import React from "react";
//import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from '@ckeditor/ckeditor5-build-classic';

// import Editor from '../';

const CommentInput = (props) => {
  // let inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName  : "cdx-input";
  let className = props.className
    ? "cdx-form-group " + props.className
    : "cdx-form-group";
  return (
    <div className={className}>
      {props.label && <label className="cdx-inpput-label">{props.label}</label>}
      <CKEditor
        className={"cdx-input"}
        editor={Editor}
        data={props.value}
        config={{
          placeholder: props.isPlaceHolder ? "" : "Post your Questions/ Insight/ recommendations....",
        }}
        onReady={(editor) => {
          editor.setData(props.value);
          // You can store the "editor" and use when it is needed.
          // console.log('Editor is ready to use!', editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          props.onChange({ target: { value: data } });
          // console.log({ event, editor, data });
        }}
        onBlur={(event, editor) => {
          // console.log('Blur.', editor);
        }}
        onFocus={(event, editor) => {
          // console.log('Focus.', editor);
        }}
      />
      {/* <div className="cdx-input">
                <textarea {...props} className={inputClassName} />
                {props.maxLength && <span className="cdx-char-count">{props.value ? props.value.length : 0}/{props.maxLength}</span>}
            </div> */}
    </div>
  );
};
export default CommentInput;
